/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Page_Online_TitleInputs */

const en_cad_page_online_title = /** @type {(inputs: Cad_Page_Online_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft Online: Use the Free CAD App in Your Browser`)
};

/**
* | output |
* | --- |
* | "CADCraft Online: Use the Free CAD App in Your Browser" |
*
* @param {Cad_Page_Online_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_page_online_title = /** @type {((inputs?: Cad_Page_Online_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Page_Online_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_page_online_title(inputs)
});
export { cad_page_online_title as "cad.page.online.title" }